import { persistReducer } from "redux-persist";
import autoMergeLevel2 from "redux-persist/es/stateReconciler/autoMergeLevel2";
import storage from "redux-persist/lib/storage";
import { userConstants } from "../constants/user.constants";

const initialAuthState = {
  user: undefined,
  authToken: undefined,
};

const persistConfig = {
  storage, 
  key: "auth", 
  stateReconciler: autoMergeLevel2
};

export const authReducer = persistReducer(persistConfig,
  (state = initialAuthState, action) => {
    switch (action.type) {
      case userConstants.Login: {
        const { accessToken, permissions, roles } = action.payload.userData;
        return { authToken: accessToken, permissions, roles, user: action.payload.userData };
      }
      case userConstants.Register: {
        const { authToken } = action.payload;

        return { authToken, user: undefined };
      }
      case userConstants.Logout: {
        // TODO: Change this code. Actions in reducer aren't allowed.
        return initialAuthState;
      }
      case userConstants.UserLoaded: {
        const { user } = action.payload;
        return { ...state, user };
      }
      case userConstants.SetUser: {
        const { user } = action.payload;
        //user.communication.sms = true;

        return { ...state, user };
      }
      default:
        return state;
    }
  }
);